import logo from 'assets/img/logo.svg'
import {Icon} from 'Icon';

import {NavLink} from 'react-router-dom';
import {MainContext, useContext} from 'mainContext';
import {useEffect} from 'react';

export default function Sidebar() {

	const {currentSong, coverSidebar, setCoverSidebar} = useContext(MainContext)

	const menus = [
		{
			title: 'Home',
			icon: 'home',
			to: '/',
		},
		{
			title: 'Search',
			icon: 'search',
			to: '/search',
		},
		{
			title: 'Your Library',
			icon: 'collection',
			to: '/collection',
		},
	]

	const playlists = [
		{id: 0, title: 'My Playlist #21'}, {id: 1, title: 'My Playlist #19'}, {
			id: 2,
			title: 'bir şarkısın sen ömür boyu sürecek',
		}, {id: 3, title: 'Kafama göre'}, {id: 4, title: 'My Playlist #17'}, {id: 5, title: 'My Playlist #20'}, {
			id: 6,
			title: 'My Playlist #16',
		}, {id: 7, title: 'My Playlist #15'}, {id: 8, title: 'Your Top Songs 2020'}, {id: 9, title: 'Taladro'}, {
			id: 10,
			title: 'coolist',
		}, {id: 11, title: 'Sleep'}, {id: 12, title: 'Sandal'}, {id: 13, title: 'Deep Focus'}, {
			id: 14,
			title: 'Radyo\'dan Beğenilenler',
		}, {id: 15, title: 'Peaceful Piano'}, {id: 16, title: 'a'}, {
			id: 17,
			title: 'Dance Pop Hits 2021 🕺💃',
		}, {id: 18, title: 'Discover Weekly'}, {id: 19, title: 'All Out 90s'}, {id: 20, title: 'All Out 00s'}, {
			id: 21,
			title: 'Hit Internazionali',
		}, {id: 22, title: 'Scenic Route'}, {id: 23, title: 'Club Hits'}, {id: 24, title: 'Dance Party'},
	]

	return (
		<aside className="w-72 p-2 pb-0 flex flex-col">
			<div className="p-4 pb-6">
				<NavLink to="/">
					<img src={logo} className="h-10"/>
				</NavLink>
			</div>
			<nav className="grid">
				{menus.map((menu, index) => (
					<NavLink
						key={index}
						to={menu.to}
						exact={menu.to === '/'}
						activeClassName="bg-white bg-opacity-20 !opacity-100"
						className="h-10 rounded transition-all gap-x-4 px-4 flex items-center text-sm font-bold text-white opacity-70 hover:opacity-100"
					>
                      <span className="w-6 h-6 flex items-center justify-center">
                        <Icon src={menu.icon}/>
                      </span>
						{menu.title}
					</NavLink>
				))}
			</nav>
			<nav className="mt-6 grid">
				<NavLink to="/" exact activeClassName="!opacity-100"
				         className="h-10 group rounded transition-all gap-x-4 px-4 flex items-center text-sm font-bold text-white opacity-70  hover:opacity-100">
                <span
	                className="bg-white w-6 h-6 rounded-sm transition-colors flex group-hover:bg-opacity-100 items-center justify-center text-black">
                    <Icon src="plus" size={12}/>
                </span>
					Create Playlist
				</NavLink>
				<NavLink to="/collection/tracks" exact activeClassName="!opacity-100"
				         className="h-10 group rounded transition-all gap-x-4 px-4 flex items-center text-sm font-bold text-white opacity-70 hover:opacity-100">
                <span
	                className="bg-gradient-to-br from-purple-700 to-indigo-300 transition-all w-6 h-6 rounded-sm flex items-center justify-center text-white">
                    <Icon src="hearth" size={12}/>
                </span>
					Liked Songs
				</NavLink>
			</nav>
			<div className="h-[1px] mx-4 bg-white bg-opacity-20 flex-shrink-0 my-2"></div>
			<nav className="flex-1 overflow-auto -mx-1 px-5 scrollbar-container">
				{playlists.map((playlist, index) => (
					<a href="#" key={index}
					   className="flex h-8 text-sm items-center opacity-70 hover:opacity-100 transition-opacity">
						{playlist.title}
					</a>
				))}
			</nav>
			<button
				className="h-10 cursor-pointer flex items-center mx-4 gap-x-5 text-sm font-semibold opacity-70 hover:opacity-100">
				<Icon src="download" size={20}/>
				Install App
			</button>
			{coverSidebar && currentSong && (
				<div className="-mx-2 pb-[100%] relative group">
					<button onClick={() => setCoverSidebar(false)}
					        className="absolute top-2 right-2 w-6 h-6 flex items-center bg-black bg-opacity-80 rounded-full justify-center z-[2] text-white text-opacity-70 transform hover:text-opacity-100 hover:scale-105 opacity-0 group-hover:opacity-100">
						<Icon src="arrowDown" size={20} className="transform rotate-90"/>
					</button>
					<div className="w-full h-full absolute inset-0">
						{currentSong?.cover && (
							<img src={currentSong.cover}
							     className="w-full h-full object-cover"/>
						)}
						{!currentSong?.cover && (
							<div className="w-full h-full bg-white bg-opacity-10 flex items-center justify-center">
								<Icon src="music" size={40}/>
							</div>
						)}
					</div>
				</div>
			)}
		</aside>
	)
}
